import React from 'react';

import Step from './Step';
import { StyledContainer, StyledTitle, StyledWrapper } from './index.styled';

const AfterSignup = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledTitle>Proces prijave</StyledTitle>
        <div>
          <Step
            index="01"
            title="Prijava"
            description="Sviđa ti se što vidiš? Učini prvi korak i prijavi se na DUMP Internship."
          />
          <Step
            index="02"
            title="Intervju"
            description="Kada se prijave zatvore, pozivamo te na kratki razgovor na kojem te želimo malo bolje upoznati."
          />
          <Step
            index="03"
            title="Prije intervjua"
            description="Ovisno o području za koje si se odlučio, potrebno je napraviti određeni zadatak prije nego što pristupiš intervjuu. Ako si prijavio dizajn, prije dolaska na intervju je potrebno napraviti moodboard. Ako si prijavio marketing, potrebno je riješiti Google formu, a ako si prijavio programiranje čeka te incijalni ispit."
          />
          <Step
            index="04"
            title="Selekcija"
            description="Prati svoj sandučić i ne propusti obavijest o našoj odluci."
          />
          <Step index="05" title="Kickoff Internshipa" description="Prva predavanja počinju!" />
        </div>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default AfterSignup;
